import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Context } from '../index';

const AdminRoute = ({ children }) => {
    const { user } = useContext(Context);

    // Если пользователь не авторизован, перенаправляем на страницу входа
    if (!user.isAuth) {
        return <Navigate to="/login" replace />;
    }

    // Если пользователь не админ, перенаправляем на главную
    if (!['main_admin', 'store_admin'].includes(user.user.role)) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AdminRoute; 